module.exports = __webpack_public_path__ + "img/line.002848be.svg";